import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NestComponent } from './nest.component';
import { NestmainComponent } from './nestmain/nestmain.component';
import {RouterModule} from '@angular/router';
import {nestRouting} from './nest.route';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatIconModule, MatSnackBarModule, MatCardModule, MatStepperModule, MatRadioModule } from '@angular/material';
import {MatDialogModule} from '@angular/material';
import { PermissionComponent } from './permission/permission.component';
import { NestbookingComponent } from './nestbooking/nestbooking.component';

import { SelecttotaldayComponent } from '../nest/selecttotalday/selecttotalday.component';
import { AddmultipleproductComponent } from '../nest/addmultipleproduct/addmultipleproduct.component';
import { AdduserpetComponent } from '../nest/adduserpet/adduserpet.component';
import { CouponComponent } from '../nest/coupon/coupon.component';
import { NestmenuComponent } from '../nest/nestmenu/nestmenu.component';
import { ProductnamefilterPipe } from './../filter/productnamefilter.pipe';
import { NestpaymodeComponent } from '../nest/nestpaymode/nestpaymode.component';
import { EmergencycontactComponent } from '../nest/emergencycontact/emergencycontact.component';
import { NestcarnivalregistrationComponent } from '../nest/nestcarnivalregistration/nestcarnivalregistration.component';
import { NestotherservicesComponent } from '../nest/nestotherservices/nestotherservices.component';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from '../common/shared.module';
import { FilterModule } from '../filter/filter.module';
@NgModule({
  imports: [
    CommonModule,
    nestRouting,
    RouterModule,
    SharedModule,
    NgxLoadingModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDialogModule,
    FilterModule,
    MatDialogModule,MatIconModule,MatSnackBarModule,MatCardModule,MatStepperModule,
    MatRadioModule
  ],
  declarations: [NestComponent, NestmainComponent, PermissionComponent, 
    NestbookingComponent, SelecttotaldayComponent, AddmultipleproductComponent,
     AdduserpetComponent, CouponComponent, NestmenuComponent,
     NestpaymodeComponent,
     EmergencycontactComponent,
     NestcarnivalregistrationComponent,
     NestotherservicesComponent
    ],
  entryComponents: [ PermissionComponent, SelecttotaldayComponent, AddmultipleproductComponent,
     AdduserpetComponent, CouponComponent, NestpaymodeComponent, EmergencycontactComponent]

})
export class NestModule { }
